import BillingSummaryCSVPreviewColumnsStrategy from './BillingSummaryCSVPreviewColumnsStrategy'

export default function BillingSummaryCSVPreviewBillableAmountStrategy() {}

BillingSummaryCSVPreviewBillableAmountStrategy.prototype = new BillingSummaryCSVPreviewColumnsStrategy();

BillingSummaryCSVPreviewBillableAmountStrategy.prototype.init = function ()
{
    BillingSummaryCSVPreviewColumnsStrategy.prototype.init.call( this );
    return this;
};

BillingSummaryCSVPreviewBillableAmountStrategy.prototype.getNumOfDataColumns = function ()
{
    return 4;
};

BillingSummaryCSVPreviewBillableAmountStrategy.prototype.addMainHeaderRowCells = function ( mainHeaderRow )
{
    this.addCell( mainHeaderRow, this.message("report.billing_summary.overall_amount.csv", [SystemSettings.currencySign]) );

    this.addBillingTypeCells( mainHeaderRow, this.getNumOfDataColumns() - 1 );
};

BillingSummaryCSVPreviewBillableAmountStrategy.prototype.addColumnGropingHeaderRowCells = function ( colGroupingRow )
{
    // do nothing
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/billingsummary/BillingSummaryCSVPreviewBillableAmountStrategy.js